import { BillingCode } from './billing-code.model';
import { CPBillingCode } from './cp-billing-code.model';
import { Crew } from './crew.model';
import { Task } from './task.model';

export class DailyReport {
  recordId?: number;
  qty?: number;
  workDate?: string = new Date().toISOString();
  relatedOSP?: number;
  code?: string;
  billingCode?: BillingCode;
  cpBillingCode?: CPBillingCode;
  task?: Task;

  //Todo: Obsolete. Remove description. Seems like we dont need it here anymore.
  description?: string;
  saved?: boolean = false;
  notes?: string;
  crew?: Crew;
  contractPartnerBillingCode_BillingCode_Code?: string;
  cpBillingCodeId?: number;
  cpBillingCodeShortDescription?: string;
  finalBillingCodeDescription?: string;

  relatedContractPartner?: number;
  withAttachments?: boolean;
  /** LH-53: files chosen for an UNSAVED report; uploaded after the report is created. */
  attachments?: File[];
  showNotes: boolean = false;
  status: string;
  crewName?: string;
  crewTitle?: string;
  workDateFormatted?: string;
  constructor(data?: any) {
    if (!data) {
      return;
    }
    this.recordId = data[3]?.value;
    this.qty = data[9]?.value;
    this.notes = data[19]?.value;
    this.workDate = data[22]?.value;
    this.relatedOSP = data[75]?.value;
    this.code = data[78]?.value;
    this.finalBillingCodeDescription = data[236]?.value;
    this.description = data[328]?.value;
    this.status = data[353]?.value;
    this.contractPartnerBillingCode_BillingCode_Code = data[396]?.value;
    this.cpBillingCodeId = data[398]?.value;
    this.cpBillingCodeShortDescription = data[399]?.value;
    // LH-53 (2026-09-05): was data[416], which is "QB Date" (a date field) — it is
    // truthy for every report, so the attachment indicator was meaningless. The real
    // flag is fid 427 "File Attachment Exists for Daily Report" (checkbox), which the
    // backend already selects. Fixed on the prod branch and never back-merged to dev.
    this.withAttachments = data[427]?.value;
    this.crewName = data[387]?.value;
  }
}
